// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"DR-z","inlineTitle":"ER-z","sponsoredAdsWrapper":"FR-z","marketplaceRecosWrapper":"GR-z"};